import type {AiTextMorphResponse} from '@PosterWhiteboard/poster/poster.types';

export const morphTextItemsForAiPrompt = async (
  itemKeyToTextMapping: Record<string, string>,
  prompt: string,
  promptFilters: Record<string, string> = {}
): Promise<AiTextMorphResponse> => {
  return window.PMW.readLocal('posterdesignmorph/generateTextForAiTextMorph', {
    mapping: itemKeyToTextMapping,
    prompt,
    promptFilters,
  }) as Promise<AiTextMorphResponse>;
};
